





















































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRPTRepports from '@/store/models/IRPTRepports';
import RPTRepportsApi from '@/store/api/RPTRepportsApi';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '@/store/api/WarehouseApi';
import UploadServiceApi from '../store/api/UploadServiceApi';
import PrintingApi from '@/store/api/PrintingApi';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import CompanyApi from '../store/api/CompanyApi';
import ICompany from '@/store/models/ICompany';
import moment from 'moment';
import ICustomer from '@/store/models/ICustomer';
import CustomerApi from '@/store/api/CustomerApi';
import { EMPTY_GUID } from '@/config/constants';
import IExciseGoodsPreview from '../store/models/IExciseGoodsPreview';
import OutboundApi from '@/store/api/OutboundApi';
import ListExciseDrinkCategoriesApi from '@/store/api/ListExciseDrinkCategoriesApi';
import IListExciseDrinkCategory from '@/store/models/IListExciseDrinkCategory';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

@Component({
    components: {
        Snackbar
    }
})

export default class Reports extends Vue {
    idCompany : string = "";
    reportList : IRPTRepports[] = [];
    reportApi : RPTRepportsApi;
    selectedReport : IRPTRepports = {} as IRPTRepports;
    dateReport: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    initialDateReport: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    endDateReport: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    menu2: boolean = false;
    menu3: boolean = false;
    menu4: boolean = false;
    selectedWarehouse : IWarehouse = {} as IWarehouse;
    selectedCompanySource: ICompany = {} as ICompany;
    warehouseApi : WarehouseApi;
    warehouseList : IWarehouse[] = [];
    showReportMovement : boolean = false;
    showReportMovementDate : boolean = false;
    showReportStock : boolean = false;
    showReportMovementBillingDate: boolean = false;
    showReportInboundOutboundSell: boolean = false;
    showReportStockByCompany: boolean = false;
    showReportMaandaangifte: boolean = false;
    settingsCompanyApi: SettingsCompanyApi;
    printingApi : PrintingApi;
    uploadServiceApi : UploadServiceApi;
    overlay: boolean = false;
    permissions : IRolePermission[] = [];
    dialogPrinting: boolean = false;
    selectedFormatToPrint: string = "excel";
    companyApi : CompanyApi;
    companyList : ICompany[] = [];
    months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    selectedMonth: string = "";
    selectedCustomers: ICustomer[] = [];
    selectedCustomer: ICustomer = {} as ICustomer;
    customerList: ICustomer[] = [];
    customerApi: CustomerApi;
    withInbound: boolean = true;
    withOutbound: boolean = true;
    withSell: boolean = true;
    isStandAlone: boolean = false;
    showReportExciseGoods: boolean = false;
    dialogExciseGoodsPreview: boolean = false;
    exciseGoodsPreview: IExciseGoodsPreview[] = [];
    outboundApi: OutboundApi;
    listExciseDrinkCategoriesApi: ListExciseDrinkCategoriesApi;
    exciseCategories: IListExciseDrinkCategory[] = [];
    constructor() {
        super();
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.reportApi = new RPTRepportsApi();
        this.warehouseApi = new WarehouseApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Reports");
        this.printingApi = new PrintingApi("Reports");
        this.uploadServiceApi = new UploadServiceApi("Reports");
        this.companyApi = new CompanyApi();
        this.customerApi = new CustomerApi();
        this.outboundApi = new OutboundApi();
        this.listExciseDrinkCategoriesApi = new ListExciseDrinkCategoriesApi();
    }

    created() {
        this.getPermissions();
        this.getReports();
        this.getWarehouses();
        this.getCompanies();
        this.getCustomers();
        this.getExciseCategories();
    }

    async getExciseCategories() {
        this.exciseCategories = await this.listExciseDrinkCategoriesApi.GetListExciseDrinkCategories();
    }

    getDrinkCategoryName(categoryIdOrName: string) {
        const category = this.exciseCategories.find(c => c.id === categoryIdOrName);
        return category ? category.name : categoryIdOrName;
    }

    normalizeExciseGoodsPreview(preview: IExciseGoodsPreview[]): IExciseGoodsPreview[] {
        return preview.map((outbound: any) => {
            const normalizedDetails = outbound.details.map((detail: any) => {
                const categoryIdOrName = detail.idDrinkCategory || detail.drinkCategory || "";
                return Object.assign({}, detail, {
                    drinkCategory: this.getDrinkCategoryName(categoryIdOrName)
                });
            });

            return Object.assign({}, outbound, {
                details: normalizedDetails
            });
        });
    }

    exciseGoodsHeaders = [
        { text: "Good", value: "goodName" },
        { text: "Good Code", value: "goodCode" },
        { text: "Drink Category", value: "drinkCategory" },
        { text: "Customs Code", value: "customsCodeUsed" },
        { text: "Alcohol %", value: "alcoholPercentage" },
        { text: "Total Goods", value: "totalGoods" },
        { text: "Liters per unit", value: "litersPerUnit" },
        { text: "Calculated Liters", value: "calculatedLiters" },
        { text: "Rate Amount Used", value: "rateAmountUsed" },
        { text: "Calculated Excise Amount", value: "calculatedExciseAmount" }
    ];

    get selectedCustomerIds(): string[] {
        if (!this.selectedCustomers || this.selectedCustomers.length === 0) {
            return [];
        }

        return this.selectedCustomers
        .filter(c => c && c.id)
        .map(c => c.id);
    }

    get InitialDateReportFormatted() {
        return this.formatDate(this.initialDateReport);
    }

    get EndDateReportFormatted() {
        return this.formatDate(this.endDateReport);
    }

    get DateReportFormatted() {
        return this.formatDate(this.dateReport);
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Users"));
        let settingsCompany = SettingsCompany.Settings.StandAlone;
        let setting = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value.toLocaleLowerCase() === "yes") {
                this.isStandAlone = true;
            }
        }
    }

    formatDate(date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate(date: string) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    get WarehouseListSort() {
        return this.warehouseList.sort((n1, n2) => {
            if (n1.name > n2.name) {
                return 1;
            }

            if (n1.name < n2.name) {
                return -1;
            }

            return 0;
        });
    }

    get CustomerListSort() {
        return [...this.customerList].sort((a, b) => a.name.localeCompare(b.name));
    }

    async getCompanies() {
        this.companyList = await this.companyApi.GetCompanies();
    }

    async getCustomers() {
        this.customerList = await this.customerApi.GetCustomersByCompanyId(this.idCompany);
    }

    async getReports() {
        let reports: IRPTRepports[] = await this.reportApi.GetRPTRepports();
        if (reports.length > 0) {
            this.reportList = reports.filter(r => r.isUserVisible === true && r.idCompany === this.idCompany);
        }
    }

    get isSuperAdmin() {
        return this.idCompany === EMPTY_GUID;
    }

    @Watch('selectedReport')
    async onChangeSelectedReport() {
        this.selectedCustomers = [];
        this.selectedCustomer = {} as ICustomer;

        if (this.selectedReport.repportName.endsWith('StockMovements')) {
            this.showReportMovement = true;
            this.showReportMovementDate = false;
            this.showReportStock = false;
            this.showReportMovementBillingDate = false;
            this.showReportInboundOutboundSell = false;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = false;
        } else if (this.selectedReport.repportName.endsWith('Stock Report')) {
            this.showReportMovement = false;
            this.showReportMovementDate = false;
            this.showReportStock = true;
            this.showReportMovementBillingDate = false;
            this.showReportInboundOutboundSell = false;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = false;
            const index = this.companyList.findIndex(c => c.id === this.idCompany);
            if (index !== -1) {
                this.selectedCompanySource = this.companyList[index];
            }
        } else if (this.selectedReport.repportName.indexOf('HAN Stock Movements Dates') >= 0) {
            this.showReportMovementDate = true;
            this.showReportMovement = false;
            this.showReportStock = false;
            this.showReportMovementBillingDate = false;
            this.showReportInboundOutboundSell = false;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = false;
        } else if (this.selectedReport.repportName === 'A4L Inbound Outbound Sell') {
            this.showReportMovement = false;
            this.showReportMovementDate = false;
            this.showReportMovementBillingDate = false;
            this.showReportStock = false;
            this.showReportInboundOutboundSell = true;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = false;
        } else if (this.selectedReport.repportName === 'ABD Stock Billing Report') {
            this.showReportMovement = false;
            this.showReportMovementDate = false;
            this.showReportMovementBillingDate = true;
            this.showReportStock = false;
            this.showReportInboundOutboundSell = false;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = false;
        } else if (this.selectedReport.repportName === 'A4L Stock By Company') {
            this.showReportMovement = false;
            this.showReportMovementDate = false;
            this.showReportMovementBillingDate = false;
            this.showReportStock = false;
            this.showReportInboundOutboundSell = false;
            this.showReportStockByCompany = true;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = false;
        } else if (this.selectedReport.repportName === 'STR Maandaangifte') {
            this.showReportMovement = false;
            this.showReportMovementDate = false;
            this.showReportMovementBillingDate = false;
            this.showReportStock = false;
            this.showReportInboundOutboundSell = false;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = true;
            this.showReportExciseGoods = false;
        } else if (this.selectedReport.repportName === 'ABD Excise Goods') {
            this.showReportMovement = false;
            this.showReportMovementDate = false;
            this.showReportMovementBillingDate = false;
            this.showReportStock = false;
            this.showReportInboundOutboundSell = false;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = true;
        } else {
            this.showReportMovement = false;
            this.showReportMovementDate = false;
            this.showReportStock = false;
            this.showReportInboundOutboundSell = false;
            this.showReportMovementBillingDate = false;
            this.showReportStockByCompany = false;
            this.showReportMaandaangifte = false;
            this.showReportExciseGoods = false;
        }

        if (this.isStandAlone) {
            let index: number = this.companyList.findIndex(c => c.id === this.idCompany);
            if (index !== -1) {
                this.selectedCompanySource = this.companyList[index];
            }
        }
    }

    @Watch('selectedWarehouse')
    async selectedWarehouseChanged() {
        let warehouses: any[] = await this.warehouseApi.IsWarehouseShared(this.idCompany, this.selectedWarehouse.id);

        if (warehouses.length > 0) {
            this.companyList = this.companyList.filter(company => company.id !== this.selectedWarehouse.idCompany);
        } else {
            this.getCompanies();
        }
    }

    calculateTotalGoods(calculatedLiters: number, litersPerUnit: number) {
        if (!calculatedLiters || !litersPerUnit || Number(litersPerUnit) === 0) {
            return 0;
        }

        return Number((Number(calculatedLiters) / Number(litersPerUnit)).toFixed(2));
    }

    async downloadExciseGoodsPreviewExcel() {
        if (!this.exciseGoodsPreview || this.exciseGoodsPreview.length === 0) {
            this.showMessageWarning("There is no data to export.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ABD Excise Goods");

        worksheet.columns = [
            { header: "Outbound Code", key: "outboundCode", width: 22 },
            { header: "Outbound Type", key: "outboundType", width: 18 },
            { header: "Date Out", key: "dateOut", width: 16 },
            { header: "Customer", key: "customerName", width: 30 },
            { header: "Country", key: "customerCountry", width: 18 },
            { header: "Good", key: "goodName", width: 40 },
            { header: "Good Code", key: "goodCode", width: 18 },
            { header: "Drink Category", key: "drinkCategory", width: 18 },
            { header: "Customs Code", key: "customsCodeUsed", width: 18 },
            { header: "Alcohol %", key: "alcoholPercentage", width: 14 },
            { header: "Total Goods", key: "totalGoods", width: 16 },
            { header: "Liters per unit", key: "litersPerUnit", width: 16 },
            { header: "Calculated Liters", key: "calculatedLiters", width: 18 },
            { header: "Rate Amount Used", key: "rateAmountUsed", width: 18 },
            { header: "Calculated Excise Amount", key: "calculatedExciseAmount", width: 24 }
        ];

        this.exciseGoodsPreview.forEach(outbound => {
            outbound.details.forEach(detail => {
                worksheet.addRow({
                    outboundCode: outbound.outboundCode,
                    outboundType: outbound.outboundType,
                    dateOut: this.formatDatePreview(outbound.dateOut),
                    customerName: outbound.customerName,
                    customerCountry: outbound.customerCountry,
                    goodName: detail.goodName,
                    goodCode: detail.goodCode,
                    drinkCategory: detail.drinkCategory,
                    customsCodeUsed: detail.customsCodeUsed,
                    alcoholPercentage: detail.alcoholPercentage,
                    litersPerUnit: detail.litersPerUnit,
                    totalGoods: this.calculateTotalGoods(detail.calculatedLiters, detail.litersPerUnit),
                    calculatedLiters: detail.calculatedLiters,
                    rateAmountUsed: detail.rateAmountUsed,
                    calculatedExciseAmount: detail.calculatedExciseAmount
                });
            });
        });

        worksheet.getRow(1).font = { bold: true };

        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.alignment = { vertical: "middle", horizontal: "left" };
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();

        const fileName = `ABD_Excise_Goods_${this.selectedMonth || "Preview"}.xlsx`;

        saveAs(
            new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }),
            fileName
        );
    }

    async generateExciseGoodsPreview() {
        this.dialogPrinting = false;

        if (this.isSuperAdmin === false) {
            if (!this.selectedMonth) {
                this.showMessageWarning("Please select a month");
                return;
            }

            this.FillInitialDateAndEndDate();
            this.overlay = true;

            try {
                const preview = await this.outboundApi.getExciseGoodsPreview(
                    this.initialDateReport,
                    this.endDateReport
                );
                this.exciseGoodsPreview = this.normalizeExciseGoodsPreview(preview || []);
                this.dialogExciseGoodsPreview = true;
            } catch (error) {
                this.showMessageError("Error generating Excise Goods preview");
            } finally {
                this.overlay = false;
            }
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    formatDatePreview(date: string) {
        if (!date) return "";
        return moment(date).format("DD/MM/YYYY");
    }

    formatExciseTariff(value: number) {
        if (value === null || value === undefined) return "";
        return Number(value).toFixed(2);
    }

    async getWarehouses() {
        let settingsCompany = SettingsCompany.Settings.StockRepportWarehousesCompanies;
        let idCompanies: ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);

        if (idCompanies.length > 0) {
            this.warehouseList = await this.warehouseApi.GetWarehousesByCompanyId(idCompanies[0].value);
        }

        this.warehouseList = this.warehouseList.concat(await this.warehouseApi.GetWarehousesShared(this.idCompany));
    }

    async printStockMovement() {
        this.dialogPrinting = false;
        if (this.isSuperAdmin === false) {
            if (this.selectedWarehouse.id !== "") {
                if (this.selectedCompanySource.id !== "") {
                    this.overlay = true;
                    let settingsCompany = "";
                    if (this.selectedReport.repportName.endsWith('StockMovements')) {
                        settingsCompany = SettingsCompany.Settings.IdStockMovementPrinting;
                    } else if (this.selectedReport.repportName.indexOf('STR Stock Report') >= 0) {
                        settingsCompany = SettingsCompany.Settings.IdStockReport;
                    } else if (this.selectedReport.repportName.endsWith('Stock Report')) {
                        settingsCompany = SettingsCompany.Settings.IdStockReport;
                    }
                    let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
                    let idsWarehouses: string[] = [];
                    idsWarehouses.push("'" + this.selectedWarehouse.id + "'");
                    let idsCustomers: string[] = this.selectedCustomerIds;

                    if (idRepport && idRepport.length > 0) {
                        let printLabelUrl: string = await this.printingApi.PrintStockMovement(
                            idRepport[0].value,
                            idsWarehouses,
                            this.selectedCompanySource.id,
                            idsCustomers,
                            this.dateReport,
                            this.selectedFormatToPrint
                        );
                        if (printLabelUrl) {
                            this.uploadServiceApi.DownloadDocuments(printLabelUrl, "StockMovement_Warehouses_" + this.dateReport + ".xlsx");
                        }
                    } else {
                        this.showMessageWarning("Setting " + settingsCompany + " could not be found");
                    }
                } else {
                    this.showMessageWarning("Please select a company");
                }
                this.overlay = false;
            } else {
                this.showMessageWarning("Please select a warehouse");
            }
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printInboundOutboundSellReport() {
        this.dialogPrinting = false;
        if (this.isSuperAdmin === false) {
            if (this.selectedCustomer.id !== "") {
                if (this.withInbound || this.withOutbound || this.withSell) {
                    const initialDate = new Date(this.initialDateReport);
                    const endDate = new Date(this.endDateReport);
                    if (initialDate > endDate) {
                        this.showMessageWarning("Initial date cannot be greater than end date");
                    } else {
                        this.overlay = true;
                        let settingsCompany = SettingsCompany.Settings.IdInboundOutboundSellPrinting;
                        let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
                        let idCustomer: string = this.selectedCustomer.id === undefined ? "" : this.selectedCustomer.id;

                        if (idRepport && idRepport.length > 0) {
                            let printLabelUrl: string = await this.printingApi.PrintInboundOutboundSellReport(idRepport[0].value, idCustomer, this.initialDateReport, this.endDateReport, this.withInbound, this.withOutbound, this.withSell, this.selectedFormatToPrint);
                            if (printLabelUrl) {
                                this.uploadServiceApi.DownloadDocuments(printLabelUrl, this.selectedCustomer.name + "_transactions_history_" + this.InitialDateReportFormatted + "_" + this.EndDateReportFormatted + ".xlsx");
                            }
                        } else {
                            this.showMessageWarning("Setting " + settingsCompany + " could not be found");
                        }
                    }
                } else {
                    this.showMessageWarning("Please select at least one of the following categories Inbounds, Outbounds or Sells");
                }
            } else {
                this.showMessageWarning("Please select a customer");
            }
            this.overlay = false;
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printStockMovementDates() {
        this.dialogPrinting = false;
        if (this.isSuperAdmin === false) {
            if (this.selectedWarehouse.id !== "") {
                if (this.selectedCompanySource.id !== "") {
                    if (this.selectedMonth) {
                        this.FillInitialDateAndEndDate();
                        this.overlay = true;
                        let settingsCompany = this.getSettingCompany(false, false);
                        let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
                        let idsWarehouses: string[] = [];
                        idsWarehouses.push("'" + this.selectedWarehouse.id + "'");

                        if (idRepport && idRepport.length > 0) {
                            let printLabelUrl: string = await this.printingApi.PrintStockMovementDates(idRepport[0].value, idsWarehouses, this.selectedCompanySource.id, this.initialDateReport, this.endDateReport, this.selectedFormatToPrint);
                            if (printLabelUrl) {
                                this.uploadServiceApi.DownloadDocuments(printLabelUrl, "StockMovementDates_Warehouses_" + this.dateReport + ".xlsx");
                            }
                        } else {
                            this.showMessageWarning("Setting " + settingsCompany + " could not be found");
                        }
                    } else {
                        this.showMessageWarning("Please select a month");
                    }
                } else {
                    this.showMessageWarning("Please select a company");
                }
                this.overlay = false;
            } else {
                this.showMessageWarning("Please select a warehouse");
            }
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printStockMovementBillingDates() {
        this.dialogPrinting = false;
        if (this.isSuperAdmin === false) {
            if (this.selectedCustomer.id !== "") {
                if (this.selectedMonth) {
                    this.FillInitialDateAndEndDate();
                    this.overlay = true;
                    let settingsCompany = this.getSettingCompany(true, false);
                    let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);

                    if (idRepport && idRepport.length > 0) {
                        let printLabelUrl: string = await this.printingApi.PrintStockMovementBillingDates(idRepport[0].value, this.selectedCustomer.id, this.initialDateReport, this.endDateReport, this.selectedFormatToPrint);
                        if (printLabelUrl) {
                            this.uploadServiceApi.DownloadDocuments(printLabelUrl, "StockMovementDates_Warehouses_" + this.dateReport + ".xlsx");
                        }
                    } else {
                        this.showMessageWarning("Setting " + settingsCompany + " could not be found");
                    }
                } else {
                    this.showMessageWarning("Please select a month");
                }
                this.overlay = false;
            } else {
                this.showMessageWarning("Please select a customer");
            }
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printMaandaangifte(selectedDay: string) {
        this.dialogPrinting = false;

        if (this.isSuperAdmin === false) {
            if (selectedDay) {
                this.overlay = true;

                try {
                    const idRepport: ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, SettingsCompany.Settings.IdMaandaangifte);

                    if (idRepport && idRepport.length > 0) {
                        const printLabelUrl: string = await this.printingApi.PrintMaandaangifte(
                            idRepport[0].value,
                            selectedDay,
                            this.selectedFormatToPrint
                        );

                        if (printLabelUrl) {
                            this.uploadServiceApi.DownloadDocuments(
                                printLabelUrl,
                                "STR_Maandaangifte_" + selectedDay + ".xlsx"
                            );
                        }
                    } else {
                        this.showMessageWarning("Setting " + SettingsCompany.Settings.IdMaandaangifte + " could not be found");
                    }
                } finally {
                    this.overlay = false;
                }
            } else {
                this.showMessageWarning("Please select an initial date");
            }
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printStockByCompanyAndDates() {
        this.dialogPrinting = false;
        if (this.isSuperAdmin === false) {
            if (this.selectedCompanySource.id !== "") {
                if (this.selectedMonth) {
                    this.FillInitialDateAndEndDate();
                    this.overlay = true;
                    let settingsCompany = this.getSettingCompany(false, true);
                    let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);

                    if (idRepport && idRepport.length > 0) {
                        let printLabelUrl: string = await this.printingApi.PrintStockMovementCompanyAndDates(idRepport[0].value, this.selectedCompanySource.id, this.initialDateReport, this.endDateReport, this.selectedFormatToPrint);
                        if (printLabelUrl) {
                            this.uploadServiceApi.DownloadDocuments(printLabelUrl, "StockMovementDates_Warehouses_" + this.dateReport + ".xlsx");
                        }
                    } else {
                        this.showMessageWarning("Setting " + settingsCompany + " could not be found");
                    }
                } else {
                    this.showMessageWarning("Please select a month");
                }
                this.overlay = false;
            } else {
                this.showMessageWarning("Please select a warehouse");
            }
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    FillInitialDateAndEndDate() {
        if (this.selectedMonth.toLowerCase() === "january") {
            this.initialDateReport = new Date().getFullYear() + "-01-01";
            this.endDateReport = new Date().getFullYear() + "-01-31";
        } else if (this.selectedMonth.toLowerCase() === "february") {
            this.initialDateReport = new Date().getFullYear() + "-02-01";
            if (this.isLeapYear(new Date().getFullYear())) {
                this.endDateReport = new Date().getFullYear() + "-02-29";
            } else {
                this.endDateReport = new Date().getFullYear() + "-02-28";
            }
        } else if (this.selectedMonth.toLowerCase() === "march") {
            this.initialDateReport = new Date().getFullYear() + "-03-01";
            this.endDateReport = new Date().getFullYear() + "-03-31";
        } else if (this.selectedMonth.toLowerCase() === "april") {
            this.initialDateReport = new Date().getFullYear() + "-04-01";
            this.endDateReport = new Date().getFullYear() + "-04-30";
        } else if (this.selectedMonth.toLowerCase() === "may") {
            this.initialDateReport = new Date().getFullYear() + "-05-01";
            this.endDateReport = new Date().getFullYear() + "-05-31";
        } else if (this.selectedMonth.toLowerCase() === "june") {
            this.initialDateReport = new Date().getFullYear() + "-06-01";
            this.endDateReport = new Date().getFullYear() + "-06-30";
        } else if (this.selectedMonth.toLowerCase() === "july") {
            this.initialDateReport = new Date().getFullYear() + "-07-01";
            this.endDateReport = new Date().getFullYear() + "-07-31";
        } else if (this.selectedMonth.toLowerCase() === "august") {
            this.initialDateReport = new Date().getFullYear() + "-08-01";
            this.endDateReport = new Date().getFullYear() + "-08-31";
        } else if (this.selectedMonth.toLowerCase() === "september") {
            this.initialDateReport = new Date().getFullYear() + "-09-01";
            this.endDateReport = new Date().getFullYear() + "-09-30";
        } else if (this.selectedMonth.toLowerCase() === "october") {
            this.initialDateReport = new Date().getFullYear() + "-10-01";
            this.endDateReport = new Date().getFullYear() + "-10-31";
        } else if (this.selectedMonth.toLowerCase() === "november") {
            this.initialDateReport = new Date().getFullYear() + "-11-01";
            this.endDateReport = new Date().getFullYear() + "-11-30";
        } else if (this.selectedMonth.toLowerCase() === "december") {
            this.initialDateReport = new Date().getFullYear() + "-12-01";
            this.endDateReport = new Date().getFullYear() + "-12-31";
        }
    }

    getSettingCompany(isBilling: boolean, isByCompany: boolean) {
        if (this.selectedMonth.toLowerCase() === "december" ||
            this.selectedMonth.toLowerCase() === "october" ||
            this.selectedMonth.toLowerCase() === "august" ||
            this.selectedMonth.toLowerCase() === "july" ||
            this.selectedMonth.toLowerCase() === "may" ||
            this.selectedMonth.toLowerCase() === "march" ||
            this.selectedMonth.toLowerCase() === "january") {
            return isBilling === true
                ? SettingsCompany.Settings.IdReportBilling31
                : isByCompany === true
                    ? SettingsCompany.Settings.IdReportStockByCompanyDestination31
                    : SettingsCompany.Settings.IdStockMovements31;
        } else if (this.selectedMonth.toLowerCase() === "april" ||
            this.selectedMonth.toLowerCase() === "june" ||
            this.selectedMonth.toLowerCase() === "september" ||
            this.selectedMonth.toLowerCase() === "november") {
            return isBilling === true
                ? SettingsCompany.Settings.IdReportBilling30
                : isByCompany === true
                    ? SettingsCompany.Settings.IdReportStockByCompanyDestination30
                    : SettingsCompany.Settings.IdStockMovements30;
        } else if (this.selectedMonth.toLowerCase() === "february") {
            if (this.isLeapYear(new Date().getFullYear())) {
                return isBilling === true
                    ? SettingsCompany.Settings.IdReportBilling29
                    : isByCompany === true
                        ? SettingsCompany.Settings.IdReportStockByCompanyDestination29
                        : SettingsCompany.Settings.IdStockMovements29;
            }
            return isBilling === true
                ? SettingsCompany.Settings.IdReportBilling28
                : isByCompany === true
                    ? SettingsCompany.Settings.IdReportStockByCompanyDestination28
                    : SettingsCompany.Settings.IdStockMovements28;
        }

        return isBilling === true
            ? SettingsCompany.Settings.IdReportBilling31
            : isByCompany === true
                ? SettingsCompany.Settings.IdReportStockByCompanyDestination31
                : SettingsCompany.Settings.IdStockMovements31;
    }

    isLeapYear(year: number) {
        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
